/* Maison ÉLAN — motion layer: reveals, header state, announcement fade. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* Header: estado compacto al hacer scroll */
  var ticking = false;
  function onScroll() {
    ticking = false;
    root.classList.toggle('elan-scrolled', (window.scrollY || 0) > 40);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* Announcement: fundido entre mensajes */
  document.querySelectorAll('[data-elan-announce]').forEach(function (track) {
    var msgs = track.querySelectorAll('.elan-announce__msg');
    if (msgs.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4200);
  });

  if (reduce || !('IntersectionObserver' in window)) return;

  /* Reveals editoriales: fade + ascenso corto, escalonado */
  var SELECTORS = [
    'main h2', 'main .rte > p', 'main a.btn', 'main a.button',
    'main [class*="product-grid-item"]', 'main .collection-list__item', 'main [class*="collection-grid-item"]',
    'main [class*="multicolumn"] article', 'main [class*="image-with-text"] img', 'main [class*="hero-image-with-text"] img',
    'main .section-testimonials__item', 'main [class*="text-with-icons"] article',
    '[data-elan-reveal]', '.elan-footer__col', '.elan-footer__top > *'
  ].join(',');
  var vh = window.innerHeight;
  var els = Array.prototype.slice.call(document.querySelectorAll(SELECTORS)).filter(function (el) {
    if (el.closest('.elan-sticky-atc, header, #product-description, .flickity-slider, .js-product-gallery')) return false;
    return el.getBoundingClientRect().top > vh * 0.92; /* lo visible al cargar nunca se oculta */
  });
  root.classList.add('elan-motion');
  els.forEach(function (el) { el.classList.add('elan-reveal'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(idx, 5) * 90 + 'ms';
      el.classList.add('is-revealed');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
  /* Seguridad: nada se queda oculto */
  setTimeout(function () { els.forEach(function (el) { el.classList.add('is-revealed'); }); }, 8000);
})();
